import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useApi } from "../../../../../shared/hooks/useApi";
import { LoaderComponent } from "../../../../../shared/components/loaders/page-loader";
import { TCAppConfig } from "../../../../../shared/app-configs/tc-app-configs";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { InnerButton } from "../../../../../shared/components/buttons/floating-button-container";
import CustomTable from "../../../../../shared/components/table/custom-table";

interface RowData {
  tcClaimsCategory: string;
  tcClaimsCategoryCertifiedWeight: string;
}

const TcStandardWeightInfo: React.FC<{ onNextTab: () => Promise<void> }> = ({
  onNextTab,
}) => {
  const [data, setData] = useState<RowData[]>([]);
  const { TE_ID, formtype } = useParams<string>();
  const { loading, executeGet, executePost } = useApi();
  const navigate = useNavigate();
  const hasCreateTc: boolean = formtype === "create-tc";
  const hasSubmitTc: boolean = formtype === "submited-tc";
  const hasRejectedTc: boolean = formtype === "rejected-tc";

  useEffect(() => {
    if (TE_ID) {
      const fetchData = async () => {
        try {
          const response: any = await executeGet(TCAppConfig.GET_CERTIFIED_WEIGHT_INFO_CONSOLIDATED_V4, {
            tcId: TE_ID,
          });
          console.log('Certified Weight API response:', response);
          const responseData = response?.data?.response;
if (responseData?.length) {
  const mappedData = responseData.map((item: any) => ({
    tcClaimsCategory:
      item.tcClaimsCategory ||
      item.tcStandard ||
      item.tcProductRawMaterialCodeClaimsCategory ||
      item.tcProductRawMaterialCodeStandardLabel ||
      "",
    tcClaimsCategoryCertifiedWeight:
      (
        item.tcClaimsCategoryCertifiedWeight ??
        item.tcProductCertifiedWeightSum ??
        0
      ).toString(),
  }));

  setData(mappedData);

  await postCertifiedWeightInfo(responseData);
}
        } catch (error) {
          console.error("Error fetching certified weight info:", error);
        }
      };
      fetchData();
    }
  }, [TE_ID]);

  // POST API call to save Certified Weight Info
  const postCertifiedWeightInfo = async (responseData: any[]) => {
    try {
      const postBody = {
        tcId: TE_ID,
        tcClaimsCategoryCertifiedWeightInformation: responseData.map((item: any) => ({
          tcClaimsCategory: item.tcClaimsCategory || item.tcStandard,
          tcClaimsCategoryCertifiedWeight:
            item.tcClaimsCategoryCertifiedWeight ??
            item.tcProductCertifiedWeightSum ??
            0,
        })),
      };
  
      await executePost(TCAppConfig.POST_CERTIFIED_WEIGHT_INFO_V4, postBody);
      await onNextTab()
    } catch (error) {
      console.error("Error posting Certified Weight Info:", error);
    }
  };

  const handleNavigate = async () => {
    navigate(`/v4/tc/${formtype}/declaration-submit-details/${TE_ID}`);
  };

  return (
    <>
      {loading ? (
        <LoaderComponent />
      ) : (
        <div>
          <Typography fontWeight={"600"}>
            TC Claims Category Certified Weight Details Summary
          </Typography>

          <Box sx={{ width: "100%", textAlign: "left", mb: 3, mt: 2 }}>
          <CustomTable
  columns={[
    { 
      accessorKey: "tcClaimsCategory", 
      header: "TC Claims Category"
    },
    { 
      accessorKey: "tcClaimsCategoryCertifiedWeight", 
      header: "TC Claims Category Certified Weight"
    },
  ]}
  data={data}
  enableTopToolbar={false}
  enableBottomToolbar={false}
  enableRowActions={false}
/>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: 2,
              gap: "0.5rem",
            }}
          >
            <NavLink to="/v4/tc-dashboard">
              <InnerButton>Home</InnerButton>
            </NavLink>
                  <NavLink to={`/v4/tc/${formtype}/incoming-tc-details/${TE_ID}`}>
                    <InnerButton>Back</InnerButton>
                  </NavLink>
                  {data?.length > 0 && (
                <InnerButton onClick={handleNavigate}>Next</InnerButton>
              )}
          </Box>
        </div>
      )}
    </>
  );
};

export default TcStandardWeightInfo;
